import { combineReducers } from "redux";
import property from "../Features/PropertyCalculator/PropertyReducers";
import tax from "../Features/TaxCalculator/TaxReducers";

export default combineReducers({ property, tax });



// WEBPACK FOOTER //
// ./src/redux/Reducers.jsx